import { ReactNode } from 'react';

interface SEOTooltipProps {
  title: string;
  content: ReactNode;
  onClose: () => void;
  darkMode: boolean;
}

export default function SEOTooltip({ title, content, onClose, darkMode }: SEOTooltipProps) {
  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
      <div className={`${darkMode ? 'bg-gray-800 border-gray-700' : 'bg-white border-gray-200'} border rounded-xl p-6 max-w-md w-full shadow-2xl transform transition-all duration-300 scale-100`}>
        <div className="flex items-center justify-between mb-4">
          <h3 className={`text-lg font-semibold ${darkMode ? 'text-white' : 'text-gray-900'}`}>
            {title}
          </h3>
          <button
            onClick={onClose}
            className={`p-1 rounded-lg ${darkMode ? 'hover:bg-gray-700 text-gray-400' : 'hover:bg-gray-100 text-gray-600'} transition-colors`}
          >
            <i className="ri-close-line text-xl"></i>
          </button>
        </div>
        <div className={`${darkMode ? 'text-gray-300' : 'text-gray-700'} leading-relaxed mb-6 whitespace-pre-line`}>
          {content}
        </div>
        
        <div className="flex items-center space-x-3">
          <div className="w-8 h-8 bg-gradient-to-r from-blue-600 to-purple-600 rounded-full flex items-center justify-center">
            <i className="ri-lightbulb-line text-white text-sm"></i>
          </div>
          <span className={`text-sm ${darkMode ? 'text-gray-400' : 'text-gray-600'}`}>
            Keyword Vocabulary Helper
          </span>
        </div>
      </div>
    </div>
  );
}
